function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Object, String) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const timerText = $helpers.getLastRefreshRelativeFormat();
    const fullText = `${$attr(`preface-text`)} ${timerText}`;
    const isCompact = $attr(`is-compact`);
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'is-compact': isCompact
        }, {
          'last-updated-container': true
        }),
      }, [__vjadeSafeCode(isCompact ? timerText : fullText)]))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;